import { Production, useProductionAvatar } from '@features/productions';
import { Avatar, AvatarProps } from '@radix-ui/themes';

interface ProductionCardWithDataProps
    extends Omit<AvatarProps, 'src' | 'fallback'> {
    production: Production;
}

export const ProductionAvatar = ({
    production,
    children,
    ...rest
}: ProductionCardWithDataProps) => {
    const { avatar } = useProductionAvatar(production);

    return (
        <Avatar {...rest} src={avatar} fallback={production.name.charAt(0)}>
            {children}
        </Avatar>
    );
};
